import { createSlice } from "@reduxjs/toolkit";

const healthCheckSlice = createSlice({
  name: "healthCheck",
  initialState: {
    loading: false,
    phishboxHealthLoading: false,
    hunterboxHealthLoading: false,
    coreResponsibles: [],
    internetStatus: [false],
    vpnStatus: [false],
    analyserStatus: [false],
    reporterStatus: [false],
    brokerStatus: "close",
    diskStatus: "close",
    emptyDiskPercentage: -1,
    ftiStatus: [false],
    mlStatus: [false],
    phishStatus: "close",
    cdrStatus: "close",
    rabbitStatus: "close",
    zsearchStatus: "close",
    mongoStatus: "close",
    phishboxInternetStatus: false,
    agenterStatus: false,
  },
  reducers: {
    TriggerHealthCheck: (state) => {
      state.loading = true;
    },
    FinishHealthCheck: (state) => {
      state.loading = false;
    },
    TriggerPhishboxHealthCheck: (state) => {
      state.phishboxHealthLoading = true;
    },
    FinishPhishboxHealthCheck: (state) => {
      state.phishboxHealthLoading = false;
    },
    TriggerHunterboxHealthCheck: (state) => {
      state.hunterboxHealthLoading = true;
    },
    FinishHunterboxHealthCheck: (state) => {
      state.hunterboxHealthLoading = false;
    },
    SuccessCoreResponsibles: (state, action) => {
      state.coreResponsibles = action.payload;
    },
    FailureCoreResponsibles: (state) => {
      state.coreResponsibles = [];
    },
    SuccessInternetStatus: (state, action) => {
      state.internetStatus = action.payload;
    },
    FailureInternetStatus: (state) => {
      state.internetStatus = [false];
    },
    SuccessVpnStatus: (state, action) => {
      state.vpnStatus = action.payload;
    },
    FailureVpnStatus: (state) => {
      state.vpnStatus = [false];
    },
    SuccessAnalyserStatus: (state, action) => {
      state.analyserStatus = action.payload;
    },
    FailureAnalyserStatus: (state) => {
      state.analyserStatus = [false];
    },
    SuccessReporterStatus: (state, action) => {
      state.reporterStatus = action.payload;
    },
    FailureReporterStatus: (state) => {
      state.reporterStatus = [false];
    },
    SuccessBrokerStatus: (state, action) => {
      state.brokerStatus = action.payload;
    },
    FailureBrokerStatus: (state) => {
      state.brokerStatus = "close";
    },
    SuccessDiskStatus: (state, action) => {
      const diskStatus = action.payload["disk-status"] ? "open" : "close";
      const emptyDiskPercentage = action.payload["empty-disk-percentage"];
      state.diskStatus = diskStatus;
      state.emptyDiskPercentage =
        emptyDiskPercentage >= 0 ? `${emptyDiskPercentage.toFixed(2)}%` : "Unknown";
    },
    FailureDiskStatus: (state) => {
      state.diskStatus = "close";
      state.emptyDiskPercentage = -1;
    },
    SuccessFtiStatus: (state, action) => {
      state.ftiStatus = action.payload;
    },
    FailureFtiStatus: (state) => {
      state.ftiStatus = [false];
    },
    SuccessMlStatus: (state, action) => {
      state.mlStatus = action.payload;
    },
    FailureMlStatus: (state) => {
      state.mlStatus = [false];
    },
    SuccessCdrStatus: (state, action) => {
      state.cdrStatus = action.payload;
    },
    FailureCdrStatus: (state) => {
      state.cdrStatus = "close";
    },
    SuccessPhishStatus: (state, action) => {
      state.phishStatus = action.payload;
    },
    FailurePhishStatus: (state) => {
      state.phishStatus = "close";
    },
    SuccessRabbitStatus: (state, action) => {
      state.rabbitStatus = action.payload;
    },
    FailureRabbitStatus: (state) => {
      state.rabbitStatus = "close";
    },
    SuccessMongoStatus: (state, action) => {
      state.mongoStatus = action.payload;
    },
    FailureMongoStatus: (state) => {
      state.mongoStatus = "close";
    },
    SuccessZsearchStatus: (state, action) => {
      state.zsearchStatus = action.payload;
    },
    FailureZsearchStatus: (state) => {
      state.zsearchStatus = "close";
    },
    SuccessPhishboxInternetStatus: (state, action) => {
      state.phishboxInternetStatus = action.payload;
    },
    FailurePhishboxInternetStatus: (state) => {
      state.phishboxInternetStatus = false;
    },
    SuccessAgenterStatus: (state, action) => {
      state.agenterStatus = action.payload;
    },
    FailureAgenterStatus: (state) => {
      state.agenterStatus = false;
    },
  },
});

export default healthCheckSlice;
